var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-white"},[_c('div',[_c('img',{staticClass:"image-block",attrs:{"alt":"Waiting...","src":require("../assets/icons/loading.gif")}}),_c('p',[_vm._v(_vm._s(_vm.$t('authentication.pleaseWait')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }